<template>
  <div>
    <van-row style="height: 38px; line-height: 30px; background: #000000">
      <van-col
        span="2"
        style="line-height: 35px"
        onclick="window.history.go(-1)"
      >
        <van-icon
          name="arrow-left"
          style="padding-top: 0px; padding-left: 10px;"
          color="#ffffff"
          size="16px"
        />
      </van-col>
      <van-col span="16" id="capitalAccountStyle">
        <div>
          <van-field
            readonly
            clickable
            :value="selectedAccount.name + '(' + selectedAccount.order + ')' + ' 余额 : ' + selectedAccount.use "
            @click="showPicker = true"
            style="
              height: 30px;
              background: #000000;
              color: #ffffff;
              line-height: 30px;
              margin-top: 4px;
              padding: 0;
              text-align: right;
            "
          />
        </div>
      </van-col>
      <van-col span="5" style="padding-right: 30px;padding-top: 5px; text-align: right; font-size: 12px;">
        <span
              v-bind:class="[selectedAccount.proportion >= 0 ? 'redText' : 'greenText']"
              >{{ selectedAccount.proportion }}%</span
            >
      </van-col>
      <van-col span="1" style="margin-left: -20px">
        <van-icon
          name="arrow-down"
          style="padding-top: 11px"
          color="#ffffff"
          size="16px"
          @click="showPicker = true"
        />
      </van-col>
    </van-row>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="capitalAccountsPickerList"
        @cancel="showPicker = false"
        @confirm="onAccountSelect"
        style="font-size: 14px"
      />
    </van-popup>
    <div class="mainSection" :style="{
    minHeight: (buySellTab === 'buy' || buySellTab === 'sell') ? '350px' : '78px'}">
      <div class="tradingSection">
        <div class="tradingnav">
            <van-row>
            <van-col span="24">
              <van-row class="btnBorder">
                <van-col
                  span="6"
                  v-bind:class="[buySellTab === 'buy' ? 'activeBtn' : '']"
                  style="border-radius: 2px 0px 0px 2px"
                  @click="setBuyTab"
                  ><span >买入</span></van-col
                >
                <van-col
                  span="4"
                  v-bind:class="[buySellTab === 'sell' ? 'activeBtnb' : '']"
                  style="border-radius: 0px 2px 2px 0px"
                  @click="setSellTab"
                  ><span >卖出</span></van-col
                >
                <van-col
                  span="6"
                  v-bind:class="[buySellTab === 'cancel' ? 'activeBtn' : '']"
                  style="border-radius: 0px 2px 2px 0px"
                  @click="setCancelTab"
                  ><span >撤单</span></van-col
                >
                <van-col
                  span="4"
                  v-bind:class="[buySellTab === 'position' ? 'activeBtn' : '']"
                  style="border-radius: 0px 2px 2px 0px"
                  @click="setPositionTab"
                  ><span >持仓</span></van-col
                >
                <van-col
                  span="4"
                  v-bind:class="[buySellTab === 'deal' ? 'activeBtn' : '']"
                  style="border-radius: 0px 2px 2px 0px"
                  @click="setDealTab"
                  ><span>查询</span></van-col
                >
              </van-row>
            </van-col>
          </van-row>
        </div>
        <div class="shareDesign">
          <van-row style="margin-top: -5px;"  v-if="buySellTab === 'buy' || buySellTab === 'sell'">
            <van-col span="6" style="text-align: left">
              <span class="shareName">{{ topData.name }}</span>
            </van-col>
            <van-col span="6">
              <span class="shareCode">{{
                selectedShare.slice(2) ? selectedShare.slice(2) : "--"
              }}</span>
            </van-col>
            <van-col span="6">
              <span
                class="currentPrice"
                v-bind:class="[topData.increase >= 0 ? 'redText' : 'greenText']"
                >{{ updown }}</span
              >
            </van-col>
            <van-col span="6" style="text-align: right">
              <span
                class="increasePrecent"
                v-bind:class="[topData.increase >= 0 ? 'redText' : 'greenText']"
                >{{ topData.increasePercent }}%</span
              >
            </van-col>
          </van-row>
        </div>
        <template v-if="buySellTab === 'buy' || buySellTab === 'sell'">
          <van-row style="padding-top: 10px">
            <!-- ======================== serach stock ================ -->
            <van-col span="15">
              <van-row style="border: 1px solid #707070">
                <van-col span="20">
                  <div id="searchStyle">
                    <van-field
                      v-model="search"
                      placeholder="代码 / 名称 / 简拼"
                      input-align="left"
                      class="placeholder-input"
                      style="
                        padding: 2px 10px;
                        line-height: 30px;
                        height: 30px;
                        background-color: #000000;
                        text-align: left !important;
                        color: #707070 !important;
                      "
                    /></div
                ></van-col>
                <van-col span="4"
                  style="background-color: #000000; cursor: pointer; height: 30px; display: flex; align-items: center; justify-content: center;"
                  @click="$router.push({ name: 'TradingSearchStock' })"
                >
                  <div style="width: 100%; height: 100%;"></div>
                </van-col>
              </van-row>
              <!-- ====================== start set price ============== -->
              <van-row style="padding-top: 10px">
                <van-col span="6">
                  <van-button 
                    v-if="buySellTab === 'buy'"
                    type="danger" 
                    size="small" 
                    style="
                      background-color: #D02E27;
                      width: 90%;
                      height: 25px; /* Manually set height */
                      min-height: 24px; /* Ensures height doesn't auto-expand */
                      font-size: 12px; /* Adjust font size */
                      padding: 8px !important; /* Reduce padding */
                      line-height: normal;
                      border: 1px solid #D02E27;
                      border-radius: 0px !important;
                    " 
                    @click="onMarketPrice"
                  >
                    {{ priceButtonLabel }}
                  </van-button>
                  <van-button 
                    v-if="buySellTab === 'sell'"
                    type="danger" 
                    size="small" 
                    style="
                      background-color: #2C71FA;
                      width: 90%;
                      height: 25px; /* Manually set height */
                      min-height: 24px; /* Ensures height doesn't auto-expand */
                      font-size: 12px; /* Adjust font size */
                      padding: 10px !important; /* Reduce padding */
                      line-height: normal;
                      border: 1px solid #2C71FA;
                      border-radius: 0px !important;
                    " 
                    @click="onMarketPrice"
                  >
                    {{ priceButtonLabel }}
                  </van-button>
                </van-col>

                <van-col v-if="showPriceControls" span="4" class="minusSignCol">
                  <van-button
                    type="info"
                    :class="buySellTab === 'buy' ? 'minusSign' : 'minusSignb'"
                    @click="onPriceControlButton('down')"
                    >-</van-button
                  >
                </van-col>
                <van-col v-if="showPriceControls" span="10" class="limitValue">
                  <div id="searchStyle">
                    <van-field
                      v-model="price"
                      style="
                        padding: 0px 10px;
                        line-height: 32px;
                        height:28px;
                        background-color: #000000;
                        border-bottom: 1px solid #707070;
                        color: #ffffff;
                      "
                      :readonly="priceButtonLabel === marketPriceLabel"
                    />
                  </div>
                </van-col>
                <van-col v-else span="18" class="limitValue">
                  <div id="searchStyle">
                    <van-field
                      v-model="price"
                      style="
                        padding: 0px 10px;
                        line-height: 32px;
                        height:28px;
                        background-color: #000000;
                        border-bottom: 1px solid #707070;
                        border-right:1px solid #707070;
                        color: #ffffff;
                      "
                      :readonly="priceButtonLabel === marketPriceLabel"
                    />
                  </div>
                </van-col>
                <van-col v-if="showPriceControls" span="4" class="plusSignCol">
                  <van-button
                    type="info"
                    :class="buySellTab === 'buy' ? 'plusSign' : 'plusSignb'"
                    @click="onPriceControlButton('up')"
                    >+</van-button
                  >
                </van-col>
              </van-row>

              <!-- ============================= start max and min value ================== -->

              <van-row style="padding-top: 8px;">
                <van-col span="11" style="text-align: left">
                  <div class="lossAmt" @click="setLimitPrice(topData.dropPrice)" style="color:#3F7A21">
                    跌停:
                    <span style="color: #3F7A21">{{ topData.dropPrice }}</span>
                  </div>
                </van-col>
                <van-col span="2"></van-col>
                <van-col span="11" style="text-align: right">
                  <div style="padding: 1px; float: right">
                    <div
                      class="lossAmt"
                      @click="setLimitPrice(topData.hardenPrice)" style="color:#D02E27"
                    >
                      涨停:
                      <span style="color: #D02E27">{{
                        topData.hardenPrice
                      }}</span>
                    </div>
                  </div>
                </van-col>
              </van-row>

              <!-- ======================== start number of stocks ============================ -->

              <van-row style="padding-top: 10px">
                <van-col span="4" class="minusSignCol">
                  <van-button
                    type="info"
                    :class="buySellTab === 'buy' ? 'minusSign' : 'minusSignb'"
                    @click="onAmountControlButton('down')"
                    >-</van-button
                  >
                </van-col>
                <van-col span="16" class="limitValue">
                  <div id="searchStyle">
                    <van-field
                      v-model="quantity"
                      :placeholder="buySellTab === 'buy' ? '买入量' : '卖出量'"
                      class="inputfield"
                      style="
                        padding: 0px 10px;
                        line-height: 30px;
                        height: 28px;
                        background-color: #000000;
                        border-bottom: 1px solid #707070;
                        color: #ffffff;
                      "
                    />
                  </div>
                </van-col>
                <van-col span="4" class="plusSignCol">
                  <van-button
                    type="info"
                    :class="buySellTab === 'buy' ? 'plusSign' : 'plusSignb'"
                    @click="onAmountControlButton('up')"
                    >+</van-button
                  >
                </van-col>
              </van-row>

              <!-- ===========================  start total number of shares =================== -->
              
                <van-row style="padding-top: 2px">
                  <van-col span="12" style="text-align: left; font-size: 14px">
                    <div class="shareavailable">
                      <span style="line-height: 30px; color: #ffffff; font-size: 12px;">
                        {{ buySellTab === "buy" ? "可买" : "可卖" }} </span
                      ><span style="color: #ffffff">&nbsp; {{ getBuyableAmount }}</span>
                      <span style="line-height: 30px; color: #ffffff; font-size: 12px;">
                        &nbsp; {{ buySellTab === "buy" ? "股" : "股" }} </span
                      >
                    </div>
                  </van-col>
                </van-row>
              
              <!-- ======================= start quick quantity select ======================== -->

              <van-row style="padding-top: 10px">
                <van-col span="6" >
                  <van-button
                    type="danger"
                    size="small"
                    class="warehouse"
                    v-bind:class="{
                      tradingQtyBuy: buySellTab === 'buy' && quntityBtn === 1,
                      tradingQtySell: buySellTab === 'sell' && quntityBtn === 1
                    }"
                    @click="setTradingQty(1)"
                    >全仓</van-button
                  >
                </van-col>
                <van-col span="6" >
                  <van-button
                    type="danger"
                    size="small"
                    class="warehouse"
                    v-bind:class="{
                      tradingQtyBuy: buySellTab === 'buy' && quntityBtn === 0.5,
                      tradingQtySell: buySellTab === 'sell' && quntityBtn === 0.5
                    }"
                    @click="setTradingQty(0.5)"
                    >半仓</van-button
                  >
                </van-col>
                <van-col span="6">
                  <van-button
                    type="danger"
                    size="small"
                    class="warehouse"
                    v-bind:class="{
                      tradingQtyBuy: buySellTab === 'buy' && quntityBtn === 0.33,
                      tradingQtySell: buySellTab === 'sell' && quntityBtn === 0.33
                    }"
                    @click="setTradingQty(0.33)"
                    >1/3仓</van-button
                  >
                </van-col>
                <van-col span="6">
                  <van-button
                    type="danger"
                    size="small"
                    class="warehouse"
                    v-bind:class="{
                      tradingQtyBuy: buySellTab === 'buy' && quntityBtn === 0.25,
                      tradingQtySell: buySellTab === 'sell' && quntityBtn === 0.25
                    }"
                    @click="setTradingQty(0.25)"
                    >1/4仓</van-button
                  >
                </van-col>
              </van-row>

              <!-- ======================== buy and sell button===================== -->

              <van-row style="padding-top: 12px">
                <van-col span="24">
                  <van-button
                    type="danger"
                    size="large"
                    style="height: 27px !important; background-color: #D02E27; width:100%; border-radius: 0px !important; line-height: 27px !important; margin-top: 2px !important;"
                    v-if="buySellTab === 'buy'"
                    @click="buySellOperation"
                    >买入</van-button
                  >
                  <van-button
                    type="primary"
                    size="large"
                    style="height: 27px !important; background-color: #2C71FA; border:#2C71FA; width:100%; border-radius: 0px !important; line-height: 27px !important;margin-top: 2px !important;"
                    v-if="buySellTab === 'sell'"
                    @click="buySellOperation"
                    >卖出</van-button
                  >
                </van-col>
                <van-col span="2"> </van-col>
              </van-row>
            </van-col>
            <!-- ==================== Start Right panel with 5 list price================================ -->
           
            <van-col span="6" id="border-box">
              <!-- <van-row>
                <van-col span="24" style="text-align:center"> <span>五格行情</span> </van-col>
              </van-row> -->
              
              <!-- ====================== sell 5 =================== -->
              <van-row>
                <van-col span="8" style="margin-left: -8px;">
                  <span class="capital1">卖5</span>
                </van-col>
                <van-col span="8">
                  <span class="capital1" style="color: #D02E27;margin-left: 10px;">{{
                    topData.sell5Price
                  }}</span>
                </van-col>
                <van-col span="8" class="flex-right">
                  <span class="capital1">{{ topData.sell5Num }}</span>
                </van-col>

              </van-row>
              <!-- ====================== sell 4 =================== -->
              <van-row>
                <van-col span="8" style="margin-left: -8px;">
                  <span class="capital1">卖4</span>
                </van-col>
                <van-col span="8">
                  <span class="capital1" style="color: #D02E27;margin-left: 10px;">{{
                    topData.sell4Price
                  }}</span>
                </van-col>
                <van-col span="8" class="flex-right">
                  <span class="capital1">{{ topData.sell4Num }}</span>
                </van-col>
              </van-row>
              <!-- ====================== sell 3 =================== -->
              <van-row>
                <van-col span="8" style="margin-left: -8px;">
                  <span class="capital1">卖3</span>
                </van-col>
                <van-col span="8">
                  <span class="capital1" style="color: #D02E27;margin-left: 10px;">{{
                    topData.sell3Price
                  }}</span>
                </van-col>
                <van-col span="8" class="flex-right">
                  <span class="capital1">{{ topData.sell3Num }}</span>
                </van-col>
              </van-row>
              <!-- ====================== sell 2 =================== -->
              <van-row>
                <van-col span="8" style="margin-left: -8px;">
                  <span class="capital1">卖2</span>
                </van-col>
                <van-col span="8">
                  <span class="capital1" style="color: #D02E27;margin-left: 10px;">{{
                    topData.sell2Price
                  }}</span>
                </van-col>
                <van-col span="8" class="flex-right">
                  <span class="capital1">{{ topData.sell2Num }}</span>
                </van-col>
              </van-row>
              <!-- ====================== sell 1 =================== -->
              <van-row>
                <van-col span="8" style="margin-left: -8px;">
                  <span class="capital1">卖1</span>
                </van-col>
                <van-col span="8">
                  <span class="capital1" style="color: #D02E27;margin-left: 10px;">{{
                    topData.sell1Price
                  }}</span>
                </van-col>
                <van-col span="8" class="flex-right">
                  <span class="capital1">{{ topData.sell1Num }}</span>
                </van-col>
              </van-row>

              <van-row style="padding: 10px 5px">
                <van-col span="24" style="border: 1px solid #656565"></van-col>
              </van-row>

              <!-- ====================== buy 1 =================== -->
              <van-row>
                <van-col span="8" style="margin-left: -8px;">
                  <span class="capital1">买1</span>
                </van-col>
                <van-col span="8">
                  <span class="capital1" style="color: #3f7a21;margin-left: 10px;">{{
                    topData.buy1Price
                  }}</span>
                </van-col>
                <van-col span="8" class="flex-right">
                  <span class="capital1">{{ topData.buy1Num }}</span>
                </van-col>
              </van-row>
              <!-- ====================== buy 2 =================== -->
              <van-row>
                <van-col span="8" style="margin-left: -8px;">
                  <span class="capital1">买2</span>
                </van-col>
                <van-col span="8">
                  <span class="capital1" style="color: #3f7a21;margin-left: 10px;">{{
                    topData.buy2Price
                  }}</span>
                </van-col>
                <van-col span="8" class="flex-right">
                  <span class="capital1">{{ topData.buy2Num }}</span>
                </van-col>
              </van-row>
              <!-- ====================== buy 3 =================== -->
              <van-row>
                <van-col span="8" style="margin-left: -8px;">
                  <span class="capital1">买3</span>
                </van-col>
                <van-col span="8">
                  <span class="capital1" style="color: #3f7a21;margin-left: 10px;">{{
                    topData.buy3Price
                  }}</span>
                </van-col>
                <van-col span="8" class="flex-right">
                  <span class="capital1">{{ topData.buy3Num }}</span>
                </van-col>
              </van-row>
              <!-- ====================== buy 2 =================== -->
              <van-row>
                <van-col span="8" style="margin-left: -8px;">
                  <span class="capital1">买4</span>
                </van-col>
                <van-col span="8">
                  <span class="capital1" style="color: #3f7a21;margin-left: 10px;">{{
                    topData.buy4Price
                  }}</span>
                </van-col>
                <van-col span="8" class="flex-right">
                  <span class="capital1">{{ topData.buy4Num }}</span>
                </van-col>
              </van-row>
              <!-- ====================== buy 1 =================== -->
              <van-row>
                <van-col span="8" style="margin-left: -8px;">
                  <span class="capital1">买5</span>
                </van-col>
                <van-col span="8">
                  <span class="capital1" style="color: #3f7a21;margin-left: 10px;">{{
                    topData.buy5Price
                  }}</span>
                </van-col>
                <van-col span="8" class="flex-right">
                  <span class="capital1">{{ topData.buy5Num }}</span>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
      </template>
      </div>
    </div>
<!-- ====================== Below table details =================== -->
    <div class="belowtable">
      <van-tabs
        v-model="active"
        id="detailTable"
        background="#c8c9cc"
        @click="onTabClick"
      >
        <!-- ====================== Tab 1 =================== -->
        <van-tab title="持仓" name="depot">
          <van-row style="padding-bottom: 5px">
            <van-col span="6" style="text-align: center; margin-top: -5px;">
              <span class="text_style">名称代码</span>
            </van-col>
            <van-col span="6" style="text-align: center; margin-top: -5px;">
              <span class="text_style">持仓/可用</span>
            </van-col>
            <van-col span="6" style="text-align: center; margin-top: -5px;">
              <span class="text_style">现价/成本</span>
            </van-col>
            <van-col span="6" style="text-align: center; margin-top: -5px;">
              <span class="text_style">浮动盈亏</span>
            </van-col>
            <!-- <van-col span="5" style="text-align: center">
              <span class="text_style">持仓市值</span>
            </van-col> -->
          </van-row>
          <van-divider style="border-bottom: 2px solid #f0f0f0 !important; margin: 5px 0;" />
          <van-row
            v-for="(item, index) in depotList"
            :key="index"
            class="depot-row"
            style="height: 40px"
            @click="onDepotItem(item)"
          >
            <van-col span="6">
              <div class="capital align-left" style="color: black">
                <p>{{ item.name }}</p>
                <p>{{ getCurrentTotal(item) }}</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="capital align-right" style="color: black">
                <p>{{ item.number }}</p>
                <p>{{ item.sellable }}</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="capital align-right" style="color: black">
                <p>
                  {{
                    bottomStockList.find((o) => o.short === item.short).price
                  }}
                </p>
                <p>{{ item.price }}</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="capital align-right" style="color: #0adc0aad">
                <p
                  v-bind:class="[
                    getFloatingProfitPercentage(item) >= 0
                      ? 'redText'
                      : 'greenText',
                  ]"
                >
                  {{ getFloatingProfitPercentage(item) }}%
                </p>
                <p
                  v-bind:class="[
                    getFloatingProfitPercentage(item) >= 0
                      ? 'redText'
                      : 'greenText',
                  ]"
                >
                  {{ getFloatingFullProfit(item) }}
                </p>
              </div>
            </van-col>
            <!-- <van-col span="5">
              <div class="capital" style="color: black">
                <p>{{ getCurrentTotal(item) }}</p>
              </div>
            </van-col> -->
          </van-row>
         
        </van-tab>
        <!-- ====================== Tab 2 =================== -->
        <van-tab title="撤单" name="cancel">
          <van-row style="padding-bottom: 5px">
            <van-col span="4" style="text-align: center; margin-top: -5px;">
              <span class="text_style">名称代码</span>
            </van-col>
            <van-col span="5" style="text-align: center; margin-top: -5px;">
              <span class="text_style">委托/状态</span>
            </van-col>
            <van-col span="5" style="text-align: center; margin-top: -5px;">
              <span class="text_style">委托/成交</span>
            </van-col>
            <van-col span="5" style="text-align: center; margin-top: -5px;">
              <span class="text_style">持仓/可卖</span>
            </van-col>
            <van-col span="5" style="text-align: center; margin-top: -5px;">
              <span class="text_style">委托时间</span>
            </van-col>
          </van-row>
          <van-divider style="border-bottom: 2px solid #f0f0f0 !important; margin: 5px 0;" />
          <van-row
            v-for="(item, index) in cancelList"
            :key="index"
            style="height: 40px"
            class="depot-row"
            @click="cancelEntrustConfirm(item)"
          >
            <van-col span="5">
              <div class="capital align-left1" style="color: black">
                <p>{{ item.name }}</p>
                <p>{{ item.code }}</p>
              </div>
            </van-col>
            <van-col span="4">
              <div class="capital align-right1" style="color: black">
                <p>{{ item.type }}</p>
                <p>{{ item.status }}</p>
              </div>
            </van-col>
            <van-col span="5">
              <div class="capital align-right1" style="color: black">
                <p>{{ item.deal }}</p>
                <p>{{ item.price !== "0.00" ? item.price : "--" }}</p>
              </div>
            </van-col>
            <van-col span="5">
              <div class="capital align-right1" style="color: black">
                <p>{{ item.number }}</p>
                <p>{{ item.finish }}</p>
              </div>
            </van-col>
            <van-col span="5">
              <div class="capital align-right1" style="color: black">
                <p>{{ item.time }}</p>
                <p>{{ item.accurate }}</p>
              </div>
            </van-col>
          </van-row>
        </van-tab>
        <!-- ====================== Tab 3 =================== -->
        <van-tab title="持仓" name="position">
          <van-row style="margin-top: -5px; margin-left: 10px;">
            <van-col span="24"><span>当前总资产(元)</span></van-col>
          </van-row>
          <van-row>
            <van-col span="24" style="font-size: 13px; margin-left: 10px;"
              ><span>{{ current_total }}</span></van-col
            >
          </van-row>
          <van-row class="rowDesign" style="border-bottom: 1px solid #dcdee0;margin-top: -5px;">
            <van-col span="8" class="columnDesign">
              <van-row class="topValue" style="font-size: 14px;"
                ><span>持仓市值(元)</span>
              </van-row>
              <van-row style="font-size: 13px" class="topValue"
                ><span style="color: #000000">{{ market }}</span>
              </van-row>
            </van-col>
            <van-col span="8" class="columnDesign">
              <van-row class="topValue" style="font-size: 14px"
                ><span>持仓比例</span>
              </van-row>
              <van-row style="font-size: 13px" class="topValue"
                ><span style="color: #000000">{{ depot_ratio }}</span>
              </van-row>
            </van-col>
            <van-col span="8" class="columnDesign" style="background: none">
              <van-row class="topValue" style="font-size: 14px"
                ><span>可用额度(元)</span>
              </van-row>
              <van-row style="font-size: 13px" class="topValue"
                ><span style="color: #000000">{{ available }}</span>
              </van-row>
            </van-col>
          </van-row>
          <van-row style="padding-top: 10px">
            <van-col span="24"><span style="padding-top: 10px; margin-left: 10px;">当前盈亏(元)</span></van-col>
          </van-row>
          <van-row>
            <van-col span="24" style="font-size: 13px; margin-left: 10px;"
              ><span v-bind:class="[profit_loss >= 0 ? 'redText' : 'greenText']">{{
                profit_loss
              }}</span
              ><span
                v-bind:class="[ratioValue >= 0 ? 'redText' : 'greenText']"
                style="padding-left: 10px"
                >{{ ratio }}</span
              ></van-col
            >
          </van-row>
          <van-row style="text-align: center; padding-top: 20px">
            <van-col span="24">
              <img src="../assets/images/capital_meter.png" />
            </van-col>
          </van-row>
          <van-row
            style="
              text-align: center;
              border-bottom: 1px solid #dcdee0;
              padding-bottom: 15px;
            "
          >
            <van-col span="12"
              ><span style="color: #d02e27">亏损警戒线 (亏损比)<br>{{ warning }} ({{ warning_line_ratio }})</span></van-col
            >
            <van-col span="12"
              ><span style="color: #3f7a21">亏损平仓线 （亏损比）<br>{{ close }} ({{ close_line_ratio }})</span></van-col
            >
          </van-row>
          <van-row class="rowDesign" style="text-align: center; border-bottom: 1px solid #dcdee0; padding-bottom: 5px;">
            <van-col span="8" class="columnDesign">
              <van-row class="topValue" style="font-size: 14px"
                ><span>总配资资金</span>
              </van-row>
              <van-row style="font-size: 13px" class="topValue"
                ><span style="color: #000000">{{ capital_total }}</span>
              </van-row>
            </van-col>
            <van-col span="8" class="columnDesign">
              <van-row class="topValue" style="font-size: 14px"
                ><span>申请额度</span>
              </van-row>
              <van-row style="font-size: 13px" class="topValue"
                ><span style="color: #000000">{{ apply_quota }}</span>
              </van-row>
            </van-col>
            <van-col span="8" class="columnDesign" style="background: none">
              <van-row class="topValue" style="font-size: 14px"
                ><span>风险保证金</span>
              </van-row>
              <van-row style="font-size: 13px" class="topValue"
                ><span style="color: #000000">{{ bond }}</span>
              </van-row>
            </van-col>
          </van-row>
          <div class="optionList" id="bottomRow">
            <van-row style="text-align: center; border-bottom: 1px solid #dcdee0; padding-bottom: 5px;padding-top: 6px;">
              <van-col span="6" style="color: #D02E27" @click="onSelectIncreaseCapitalInfo"
                ><span class="text-border">追加配资</span></van-col
              >
              <van-col span="6" style="color: #D02E27" @click="onSelectIncreaseBondInfo"
                ><span class="text-border">追加保证金</span></van-col
              >
              <van-col span="6" style="color: #D02E27" @click="closeCapitalAccount"
                ><span class="text-border">申请结算</span></van-col
              >
              <van-col span="6" style="color: #D02E27" @click="capitalFundDetails"
                  ><span class="text-border">资金明细</span></van-col
              >
            </van-row>
          </div>
          <div style="padding-top: 15px;">
            <van-row class="rowDesign" style="padding-bottom: 10px;margin-top: -5px;">
            <van-col span="2" style="text-align: center">
            </van-col>
            <van-col span="6" style="text-align: center">
              <span class="text_style">名称代码</span>
            </van-col>
            <van-col span="5" style="text-align: center">
              <span class="text_style">持仓/可用</span>
            </van-col>
            <van-col span="5" style="text-align: center">
              <span class="text_style">现价/成本</span>
            </van-col>
            <van-col span="6" style="text-align: center">
              <span class="text_style">浮动盈亏</span>
            </van-col>
          </van-row>
          <van-row
            v-for="(item, index) in depotList"
            :key="index"
            style="height: 40px"
            @click="onDepotItem(item)"
          >
            <van-col span="2" >
              <van-dropdown-menu class="custom-dropdown" style="margin-top: 5px;">
                <van-dropdown-item>
                    <van-row gutter="10">
                      <van-col span="8" style="text-align: center">
                        <van-button round size="small" style="background-color: #0D268D;border: #0D268D; color:#ffffff" @click="holdBuy()">买入</van-button>
                      </van-col>
                      <van-col span="8" style="text-align: center">
                        <van-button round size="small" style="background-color: #0D268D;border: #0D268D; color:#ffffff" @click="holdSell()">卖出</van-button>
                      </van-col>
                      <van-col span="8" style="text-align: center">
                        <van-button round size="small" style="background-color: #0D268D;border: #0D268D; color:#ffffff" @click="MarketGo(item)">行情</van-button>
                      </van-col>
                    </van-row>
                </van-dropdown-item>
              </van-dropdown-menu>
            </van-col>
            <van-col span="6">
              <div class="capital align-left" style="color: black">
                <p>{{ item.name }}</p>
                <p>{{ getCurrentTotal(item)  }}</p>
              </div>
            </van-col>
            <van-col span="5">
              <div class="capital align-right" style="color: black">
                <p>{{ item.number }}</p>
                <p>{{ item.sellable }}</p>
              </div>
            </van-col>
            <van-col span="5">
              <div class="capital align-right" style="color: black">
                <p>
                  {{
                    bottomStockList.find((o) => o.short === item.short).price
                  }}
                </p>
                <p>{{ item.price }}</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="capital align-right" style="color: #0adc0aad">
                <p
                  v-bind:class="[
                    getFloatingProfitPercentage(item) >= 0
                      ? 'redText'
                      : 'greenText',
                  ]"
                >
                  {{ getFloatingProfitPercentage(item) }}%
                </p>
                <p
                  v-bind:class="[
                    getFloatingProfitPercentage(item) >= 0
                      ? 'redText'
                      : 'greenText',
                  ]"
                >
                  {{ getFloatingFullProfit(item) }}
                </p>
              </div>
            </van-col>
          </van-row>
          </div>
          
        </van-tab>
        <!-- ====================== Tab 4 =================== -->
        <van-tab title="成交" name="deal">
          
        </van-tab>
      </van-tabs>

      <!-- New Tabs -->
      <van-tabs
        v-if="active === 'deal'"
        v-model="activeSubTab"
        id="detailTable1"
        background="#c8c9cc"
        @click="onSubTabClick"
      >
        <!-- ====================== Tab 1 =================== -->
        <van-tab title="委托查询" name="entrustDeal">
          <van-row style="padding-bottom: 5px">
            <van-col span="4" style="text-align: center; margin-top: 10px;">
              <span class="text_style">委托时间</span>
            </van-col>
            <van-col span="5" style="text-align: center; margin-top: 10px;">
              <span class="text_style">名称代码</span>
            </van-col>
            <van-col span="5" style="text-align: center; margin-top: 10px;">
              <span class="text_style">委托/状态</span>
            </van-col>
            <van-col span="5" style="text-align: center; margin-top: 10px;">
              <span class="text_style">委托/成交</span>
            </van-col>
            <van-col span="5" style="text-align: center; margin-top: 10px;">
              <span class="text_style">持仓/可卖</span>
            </van-col>
          </van-row>
          <van-divider style="border-bottom: 2px solid #f0f0f0 !important; margin: 5px 0;" />
          <van-row
            v-for="(item, index) in entrustLogList"
            :key="index"
            class="depot-row"
            style="height: 40px"
          >
          <van-col span="4">
              <div class="capital align-left1" style="color: black">
                <p>{{ item.time }}</p>
                <p>{{ item.accurate }}</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="capital align-right1" style="color: black">
                <p>{{ item.name }}</p>
                <p>{{ item.code }}</p>
              </div>
            </van-col>
            <van-col span="5">
              <div class="capital align-right1" style="color: black">
                <p>{{ item.type }}</p>
                <p>{{ item.status }}</p>
              </div>
            </van-col>
            <van-col span="5">
              <div class="capital align-right1" style="color: black">
                <p>{{ item.deal != 0 ? item.deal : "--" }}</p>
                <p>{{ item.price != 0 ? item.price : "--" }}</p>
              </div>
            </van-col>
            <van-col span="4">
              <div class="capital align-right1" style="color: black">
                <p>{{ item.number }}</p>
                <p>{{ item.finish }}</p>
              </div>
            </van-col>
            
          </van-row>
        </van-tab>
        <!-- ====================== Tab 2 =================== -->
        <van-tab title="成交记录" name="depotDeal">
          <van-row style="padding-bottom: 5px;">
            <van-col span="6" style="text-align: center; margin-top: 10px;">
              <span class="text_style">委托时间</span>
            </van-col>
            <van-col span="6" style="text-align: center; margin-top: 10px;">
              <span class="text_style">名称代码</span>
            </van-col>
            <van-col span="6" style="text-align: center; margin-top: 10px;">
              <span class="text_style">买卖/数量</span>
            </van-col>
            <van-col span="6" style="text-align: center; margin-top: 10px;">
              <span class="text_style">价格/总额</span>
            </van-col>
            <!-- <van-col span="5" style="text-align: center">
              <span class="text_style">手续费</span>
            </van-col> -->
          </van-row>
          <van-divider style="border-bottom: 2px solid #f0f0f0 !important; margin: 0px 0;" />
          <van-row
            v-for="(item, index) in dealLogList"
            :key="index"
            class="depot-row"
            style="height: 40px"
            @click="showPopup(item.id)"
          >
            <van-col span="6">
              <div class="capital align-left" style="color: black">
                <p>{{ item.time }}</p>
                <p>{{ item.accurate }}</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="capital align-right" style="color: black">
                <p>{{ item.name }}</p>
                <p>{{ item.code }}</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="capital align-right" style="color: black">
                <p>{{ item.type }}</p>
                <p>{{ item.number }}</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="capital align-right" style="color: black">
                <p>{{ item.price }}</p>
                <p>{{ item.total }}</p>
              </div>
            </van-col>
            <!-- <van-col span="5">
              <div class="capital align-right1" style="color: black">
                <p>{{ item.fee }}</p>
              </div>
            </van-col> -->
          </van-row>
          <!-- ============================================ Deal POPup =========================================== -->
          <van-popup v-model="showDealPopup" round style="width: 90%">
            <table style="width: 100%; padding: 20px">
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>日期时间</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.time }} {{ dealData.accurate }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>业务名称</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.type }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>股票代码</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.name }} {{ dealData.code }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>成交数量</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.number }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>成交价格</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.price }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>成交金额</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.total }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>券商佣金</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.commission }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>过户费</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.change }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>印花税</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.stamp }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>产品处理费</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.extra_fee1 }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>结算费用</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.extra_fee2 }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>平台费用</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.extra_fee3 }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>总金额</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.totalplus }}</span>
                </td>
              </tr>
            </table>
            <van-row style="padding: 10px">
              <van-col span="2"></van-col>
              <van-col span="20">
                <van-button
                  type="danger"
                  size="normal"
                  style="width: 100%; height: 34px"
                  @click="closePopup()"
                  >取消</van-button
                >
              </van-col>
              <van-col span="2"></van-col>
            </van-row>
          </van-popup>
        </van-tab>
        <!-- ====================== Tab 3 =================== -->
        <van-tab title="系统平仓" name="closeDeal">
          <van-row style="padding-bottom: 5px">
            <van-col span="6" style="text-align: center; margin-top: 10px;">
              <span class="text_style">日期/时间</span>
            </van-col>
            <van-col span="6" style="text-align: center; margin-top: 10px;">
              <span class="text_style">名称/代码</span>
            </van-col>
            <van-col span="6" style="text-align: center; margin-top: 10px;">
              <span class="text_style">买卖/数量</span>
            </van-col>
            <van-col span="6" style="text-align: center; margin-top: 10px;">
              <span class="text_style">单价/总价</span>
            </van-col>
          </van-row>
          <van-divider style="border-bottom: 2px solid #f0f0f0 !important; margin: 5px 0;" />
          <van-row
            v-for="(item, index) in unwindData"
            :key="index"
            class="depot-row"
            style="height: 40px"
            @click="showPopup(item.id)"
          >
            <van-col span="6">
              <div class="capital align-left" style="color: black">
                <p>{{ item.time }}</p>
                <p>{{ item.accurate }}</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="capital align-right" style="color: black">
                <p>{{ item.name }}</p>
                <p>{{ item.code }}</p>
              </div>
            </van-col>
            <van-col span="5">
              <div class="capital align-right" style="color: black">
                <p>{{ item.type }}</p>
                <p>{{ item.number }}</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="capital align-right" style="color: black">
                <p>{{ item.price }}</p>
                <p>{{ item.total }}</p>
              </div>
            </van-col>
          </van-row>
        </van-tab>
        <!-- ====================== Tab 4 =================== -->
        <van-tab title="对账单" name="statementDeal">
          <van-row style="padding-bottom: 5px">
            <van-col span="8" style="text-align: center; margin-top: 10px;">
              <span class="text_style">日期</span>
            </van-col>
            <van-col span="8" style="text-align: center; margin-top: 10px;">
              <span class="text_style">名称/类型</span>
            </van-col>
            <van-col span="8" style="text-align: center; margin-top: 10px;">
              <span class="text_style">金额/余额</span>
            </van-col>
          </van-row>
          <van-divider style="border-bottom: 2px solid #f0f0f0 !important; margin: 5px 0;" />
          <van-row
            v-for="(item, index) in capitalData"
            :key="index"
            class="depot-row"
            style="height: 40px"
          >
            <van-col span="8">
              <div class="capital align-left2" style="color: black">
                <p>{{ item.time }}</p>
                <p>{{ item.accurate }}</p>
              </div>
            </van-col>
            <van-col span="10">
              <div class="capital align-right2" style="color: black">
                <p>{{ item.name }}</p>
                <p>{{ item.type }}</p>
              </div>
            </van-col>
            <van-col span="6">
              <div class="capital align-right2" style="color: black">
                <p>{{ item.number }}</p>
                <p>{{ item.balance }}</p>
              </div>
            </van-col>
          </van-row>
          <!-- ============================================ Deal POPup =========================================== -->
          <van-popup v-model="showDealPopup" round style="width: 90%">
            <table style="width: 100%; padding: 20px">
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>日期时间</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.time }} {{ dealData.accurate }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>业务名称</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.type }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>股票代码</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.name }} {{ dealData.code }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>成交数量</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.number }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>成交价格</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.price }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>成交金额</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.total }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>券商佣金</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.commission }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>过户费</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.change }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>印花税</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.stamp }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>产品处理费</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.extra_fee1 }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>结算费用</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.extra_fee2 }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>平台费用</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.extra_fee3 }}</span>
                </td>
              </tr>
              <tr class="dealPopupRow">
                <td style="width: 50%">
                  <span>总金额</span>
                </td>
                <td style="width: 50%; text-align: right">
                  <span>{{ dealData.totalplus }}</span>
                </td>
              </tr>
            </table>
            <van-row style="padding: 10px">
              <van-col span="2"></van-col>
              <van-col span="20">
                <van-button
                  type="danger"
                  size="normal"
                  style="width: 100%; height: 34px"
                  @click="closePopup()"
                  >取消</van-button
                >
              </van-col>
              <van-col span="2"></van-col>
            </van-row>
          </van-popup>
        </van-tab>
      </van-tabs>

    </div>
    <!-- ============================== Start change channel popup ========================== -->
    <van-popup
      v-model="showTradeChannelPopup"
      closeable
      id="tradingAgreePop"
      style="width: 85%"
    >
      <div
        v-html="trade_rules_content_top"
        style="overflow-y: scroll; max-height: 320px; margin: 10px"
      ></div>
      <div style="text-align: center; padding: 0px 10px">
        <van-button
          type="danger"
          size="large"
          @click="agreeTradeRules"
          style="width: 50%; height: 30%; padding: 3px; border-radius: 6px"
          >我已经明白
        </van-button>
        <div
          v-html="trade_rules_content_bottom"
          style="text-align: center; margin: 10px"
        ></div>
      </div>
    </van-popup>
    <!-- ============================== End change channel popup ========================== -->
    <CommonLoading ref="commonLoader"></CommonLoading>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import CommonLoading from "./CommonLoading";
export default {
  name: "Trading",
  components: {
    CommonLoading,
  },
  data() {
    return {
      buySellTab: "buy",
      active: "depot",
      activeSubTab: "entrustDeal",
      search: "",
      price: 0,
      quantity: '',
      sellableQty: 0,
      selectedShare: "",
      timerRef: null,
      topData: {
        name: "--",
        increase: "--",
        price: "--",
        increasePercent: "--",
        dropPrice: "--",
        hardenPrice: "--",
        sell5Price: "--",
        sell4Price: "--",
        sell3Price: "--",
        sell2Price: "--",
        sell1Price: "--",
        sell5Num: "--",
        sell4Num: "--",
        sell3Num: "--",
        sell2Num: "--",
        sell1Num: "--",
        buy1Price: "--",
        buy2Price: "--",
        buy3Price: "--",
        buy4Price: "--",
        buy5Price: "--",
        buy1Num: "--",
        buy2Num: "--",
        buy3Num: "--",
        buy4Num: "--",
        buy5Num: "--",
      },
      selectedAccount: { name: "--", order: "--" },
      marketPriceBuyLabel: "对手最优价格",
      marketPriceSellLabel: "对手最优价",
      limitPriceLabel: "限价",
      marketPriceLabel: "市价",
      priceButtonLabel: "",
      capitalAccountList: [],
      showPicker: false,
      capitalAccountsPickerList: [],
      depotList: [],
      cancelList: [],
      entrustLogList: [],
      dealLogList: [],
      dealData: {},
      bottomStockList: [],
      timmerFrequncy: 2000,
      timmerRef: null,
      showDealPopup: false,
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      quntityBtn: null,
      unwindData: [],
      capitalData: [],
      showPriceControls: false,
      current_total: "0.00",
      market: "0.00",
      depot_ratio: "",
      available: "0.00",
      profit_loss: "0.00",
      ratio: "0.00",
      ratioValue: "0.00",
      warning: "0.00",
      close: "0.00",
      close_line_ratio:"0.00",
      warning_line_ratio:"0.00",
      capital_total: "0.00",
      apply_quota: "0.00",
      bond: "0.00",
    };
  },
  watch: {
    quantity(val) {
      const intOnly = String(val).replace(/[^\d]/g, '');
      if (val !== intOnly) {
        this.quantity = intOnly;
      }
    },
    price: function (val) {
      if (this.priceButtonLabel === this.limitPriceLabel) {
        this.buyableAmountCalculation();
      }
    },
    search: function (val) {
      if (val) {
        //this.selectedShare = val;
        //this.loadMarketData();
        this.query_stocks(val);
      }
    },
    buySellTab: function () {
      if (this.priceButtonLabel === this.marketPriceLabel) {
        this.price =
          this.buySellTab === "buy"
            ? this.marketPriceBuyLabel
            : this.marketPriceSellLabel;
      }
      //set qty input 0 when tab is changed
      this.quantity = '';
      this.quntityBtn = null;
    },
  },
  computed: {
    getBuyableAmount() {
      if (this.buySellTab === "buy") {
        return this.buyableAmountCalculation();
      } else {
        //when showing sell tab, check selected share depot in the list
        //and show sellabel qty
        if (this.selectedShare) {
          let shareItem = this.depotList.find(
            (o) => o.short === this.selectedShare
          );
          if (shareItem) {
            this.sellableQty = shareItem.sellable;
          } else {
            this.sellableQty = 0;
          }
        }
        return this.sellableQty;
      }
    },
    updown() {
      let val = (this.topData.price - this.topData.yesterdayClosePrice).toFixed(
        2
      );
      return isNaN(val) ? "--" : val;
    },
  },
  methods: {
    holdBuy(){
      this.closePossitonDropdown()
      this.setBuyTab()
    },
    holdSell(){
      this.closePossitonDropdown()
      this.setSellTab()
    },
    MarketGo(item){
      this.closePossitonDropdown()
      this.$router.push({name: "Kline",params: { code: item.short }, query: {navigateUrl: "Trading" }} );
    },
    closePossitonDropdown() {
      document.body.classList.remove("van-overflow-hidden");
      // Force hide the popup dropdown
      setTimeout(() => {
        document.querySelectorAll(".van-popup.van-popup--top.van-dropdown-item__content").forEach(el => {
          el.style.display = "none";
        });
      }, 100); // Small delay to allow Vue to update
    },
    onSelectIncreaseCapitalInfo() {
      sessionStorage.setItem('cid', this.selectedAccount.cid)
      localStorage.setItem("isCapitalPage", true);
      this.$router.push({
          name: "IncreaseCapitalInfo",
          params: { total: this.current_total, order: this.selectedAccount.order, navigateUrl: "Trading" },
        });
    },
    onSelectIncreaseBondInfo() {
      sessionStorage.setItem('cid', this.selectedAccount.cid)
      localStorage.setItem("isCapitalPage", true);
      this.$router.push({
          name: "IncreaseBondInfo",
          params: { total: this.current_total, order: this.selectedAccount.order, navigateUrl: "Trading" },
        });
    },
    closeCapitalAccount() {
      Dialog.confirm({
        title: "申请结算",
        message: "您是否确定结算该合约?",
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      })
        .then(() => {
          // on confirm
          this.operationSettlement(this.selectedAccount.cid);
        })
        .catch(() => {
          // on cancel
        });
    },
    operationSettlement(cid) {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "settlement",
            token: sessionStorage.getItem("token"),
            cid: cid,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            clearInterval(that.timerRef);
            that.$store.commit('setSelectedCid', '');
            that.$toast.success({
              message: res.data.msg,
              type: "success",
              duration: 1000,
            });
            that.$router.push('/capital_account?activeTab=2')
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    capitalFundDetails() {
      sessionStorage.setItem('cid', this.selectedAccount.cid)
      localStorage.setItem("isCapitalPage", true);
      this.$router.push({
        name: "CapitalFundDetails",
        params: {navigateUrl: "Trading" },
      });
    },  
    query_stocks(query) {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "get_stocks",
            words: query,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length >= 1) {
              that.selectedShare = res.data.data[0].short;
              that.loadMarketData(true);
            }
          } else if (res.data.code === 0) {
            that.$toast.fail(res.data.msg);
          } else if (res.data.code === -1) {
            that.$logout(res.data.msg);
          }
        });
    },
    cancelEntrustConfirm(item) {
      let that = this;
      Dialog.confirm({
        title: "撤单",
        message: "您将要撤销该股票，是否继续？",
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      })
        .then(() => {
          that.cancelEntrust(item);
        })
        .catch(() => {});
    },
    cancelEntrust(item) {
      let that = this;
      this.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "cancel_entrust",
          token: sessionStorage.getItem("token"),
          cid: that.selectedAccount.cid,
          order: item.id,
        },
      })
        .then(function (res) {
          if (res.data.code == 1) {
            Toast.success(res.data.msg);
            that.onTabClick();
          } else if (res.data.code == 0) {
            Toast.fail(res.data.msg);
          }
        })
        .catch(function () {
          Toast.fail();
        });
    },
    setBuyTab() {
      this.buySellTab = 'buy';
      this.active = 'depot';  
    },
    setSellTab() {
      this.buySellTab = 'sell';
      this.active = 'depot';  
    },
    setCancelTab() {
      this.buySellTab = 'cancel';
      this.active = 'cancel';  
    },
    setPositionTab() {
      this.buySellTab = 'position';
      this.active = 'position';  
    },
    setDealTab(){
      this.buySellTab = 'deal';
      this.active = 'deal';  
    },
    onTabClick() {
      switch (this.active) {
        case "depot":
          this.active = "depot";
          this.getDepotStock();
          break;
        case "cancel":
          this.geCancelOrders();
          break;
        case "position":
          this.getstrategyInfo();
          break;
        case "deal":
          this.getDealLog();
          this.getEntrustLog();
          this.getDepotStock();
          this.getCapitalData();
          break;
        default:
          break;
      }
    },
    getstrategyInfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_detailed",
            token: sessionStorage.getItem("token"),
            cid: that.selectedAccount.cid,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var info = res.data.data;
            that.current_total = info.total;
            that.market = info.market;
            that.depot_ratio = info.depot_ratio;
            that.available = info.available;
            that.profit_loss = info.profit_loss;
            that.ratio = info.ratio;
            that.ratioValue = that.ratio.replace(/['%]+/g, "");
            that.warning = info.warning;
            that.close = info.close;
            that.warning_line_ratio = info.warning_line_ratio;
            that.close_line_ratio = info.close_line_ratio;
            that.capital_total = info.capital_total;
            that.apply_quota = info.apply_quota;
            that.bond = info.bond;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    onSubTabClick() {
      switch (this.activeSubTab) {
        case "entrustDeal":
          this.getEntrustLog();
          break;
        case "depotDeal":
          this.getDepotStock();
          break;
        case "closeDeal":
          this.getDealLog();
          break;
        case "statementDeal":
          this.getCapitalData();
          break;
      }
    },
    getDepotStock() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "depot_stock",
            token: sessionStorage.getItem("token"),
            cid: this.selectedAccount.cid,
          },
        })
        .then(function (res) {
          that.depotList = [];
          if (res.data.code == 1) {
            that.depotList = res.data.data;
            that.loadMarketData();
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    geCancelOrders() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "cancel_order",
            token: sessionStorage.getItem("token"),
            cid: this.selectedAccount.cid,
          },
        })
        .then(function (res) {
          that.cancelList = [];
          if (res.data.code == 1) {
            that.cancelList = res.data.data;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getEntrustLog() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "entrust_log",
            token: sessionStorage.getItem("token"),
            cid: this.selectedAccount.cid,
          },
        })
        .then(function (res) {
          that.entrustLogList = [];
          if (res.data.code == 1) {
            that.entrustLogList = res.data.data;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    getDealLog() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "deal_log",
            token: sessionStorage.getItem("token"),
            cid: this.selectedAccount.cid,
          },
        })
        .then(function (res) {
          that.dealLogList = [];
          let unwindData = [];
          if (res.data.code == 1) {
            that.dealLogList = res.data.data;
            for (let i = 0, len = that.dealLogList.length; i < len; i++) {
              if (that.dealLogList[i].depot_mold === 1) {
                unwindData.push(that.dealLogList[i]);
              }
            }
            that.unwindData = unwindData;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    showPopup(dealId) {
      // this.showDealPopup = true;
      let that = this;
      // Toast.loading({
      //   forbidClick: true,
      // });
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "all_deal",
            token: sessionStorage.getItem("token"),
            deal_id: dealId,
          },
        })
        .then(function (res) {
          // Toast.clear();
          that.$refs.commonLoader.hideCommonLoadigIcon();
          if (res.data.code == 1) {
            that.dealData = res.data.data[0];
            that.showDealPopup = true;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    },
    closePopup() {
      this.showDealPopup = false;
    },
    setTradingQty(ratio) {
      if (this.buySellTab === "buy") {
        let qty = parseFloat(this.buyableAmountCalculation() * ratio).toFixed(
          0
        );
        qty = parseInt(qty / 100) * 100;
        this.quantity = qty < 0 ? 0 : qty;
      } else {
        let qty = parseFloat(this.sellableQty * ratio).toFixed(0);
        qty = parseInt(qty / 100) * 100;
        this.quantity = qty < 0 ? 0 : qty;
      }
      this.quntityBtn = ratio;
    },
    buyableAmountCalculation() {
      if (this.selectedAccount == null || this.selectedShare === "") return 0;
      let use = parseFloat(this.selectedAccount.use);
      let price =
        this.priceButtonLabel === this.marketPriceLabel
          ? parseFloat(this.topData.price)
          : this.price;
      let qty = use / price;
      qty = Math.floor(qty);
      return isNaN(qty) ? "--" : qty;
    },
    onAmountControlButton(direction) {
      let currentQty = parseInt(this.quantity) || 0;
      if (direction === "up") {
        this.quantity = currentQty + 100;
      }
      if (direction === "down") {
        if (currentQty >= 100) {
          this.quantity = currentQty - 100;
          } else {
            this.quantity = 0;
          }
      }
    },
    /**
     * method to controll price +,- buttons
     * 1. check if limit price set, if not change to limit price
     * 2. if direction up, increase price by 0.05
     * 3. if direction down, decriment price by 0.05
     */
    onPriceControlButton(direction) {
      if (this.priceButtonLabel !== this.limitPriceLabel) {
        this.priceButtonLabel = this.limitPriceLabel;
        this.price = this.topData.price;
        return;
      }
      if (direction === "up") {
        this.price = parseFloat(this.price) + 0.01;
      }
      if (direction === "down") {
        this.price = parseFloat(this.price) - 0.01;
      }

      this.price = parseFloat(this.price).toFixed(2);
    },
    setLimitPrice(price) {
      if (this.priceButtonLabel !== this.limitPriceLabel) {
        this.priceButtonLabel = this.limitPriceLabel;
      }
      this.price = price;
    },
    onMarketPrice() {
    if (this.priceButtonLabel === this.marketPriceLabel) {
      this.priceButtonLabel = this.limitPriceLabel;
      this.price = this.topData.price;
      this.showPriceControls = true; 
    } else {
      this.priceButtonLabel = this.marketPriceLabel;
      this.price =
        this.buySellTab === "buy"
          ? this.marketPriceBuyLabel
          : this.marketPriceSellLabel;
      this.showPriceControls = false;
    }
    },
    /**
     * load capital account info
     * 1.get capital data
     * 2.set first account as selected account
     * 3.load depot stock
     */
    getCapitalAccounts() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_operate",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.capitalAccountList = res.data.data;
            if (that.capitalAccountList.length == 0) {
              Dialog.confirm({
                message: "还没有有配资合约，请先完成配资",
                cancelButtonText: "取消",
                confirmButtonText: "前去配置配资",
              })
                .then(() => {
                  that.$router.push({ name: "CreateCapitalAccounts" });
                })
                .catch(() => {
                  that.$router.go(-1);
                });
            } else {
              if (that.$store.state.selectedCid) {
                that.selectedAccount = that.capitalAccountList.find(
                  (o) => o.cid == that.$store.state.selectedCid
                );
              } else {
                that.selectedAccount = that.capitalAccountList[0];
              }
              //generate list for picker
              that.capitalAccountsPickerList = [];
              that.capitalAccountList.forEach(function (element, index) {
                let item = {
                  text:
                    element.name +
                    "(" +
                    element.order +
                    ") 余额:" +
                    element.use,
                  value: index,
                };
                that.capitalAccountsPickerList.push(item);
              });
              that.getDepotStock();
            }
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          } else if (res.data.code == -1) {
            that.$logout(res.data.msg);
          }
        });
    },
    getCapitalData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "capital_log",
            token: window.sessionStorage.getItem("token"),
            cid: this.selectedAccount.cid,
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            let capitalData = res.data.data;
            for (let i = 0, len = capitalData.length; i < len; i++) {
              capitalData[i].accurate = that
                .$moment(capitalData[i].time)
                .format("HH:mm:ss");
              capitalData[i].time = that
                .$moment(capitalData[i].time)
                .format("YYYY.MM.DD");
            }
            that.capitalData = capitalData;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    /**
     * load market data from datasource
     * 1.get all market data from datasource
     * 2.set top data part
     * 3.set bottom data parts
     */
    loadMarketData(changeInputPrice = false) {
      let that = this;

      let stockList = [];
      that.depotList.forEach((item) => {
        stockList.push(item.short);
      });

      let url =
        "https://sqt.gtimg.cn/utf8/q=" +
        that.selectedShare +
        "," +
        stockList.toString();
      $.ajax({
        url: url,
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          if (that.selectedShare) {
            that.topData = that.getStockObject(that.selectedShare);
            if (
              changeInputPrice &&
              that.priceButtonLabel === that.limitPriceLabel
            ) {
              that.price = that.topData.price;
            }
          }
          that.bottomStockList = [];
          stockList.forEach((item) => {
            that.bottomStockList.push(that.getStockObject(item));
          });
        },
      });
    },
    getCurrentTotal(share) {
      let marketData = this.bottomStockList.find(
        (o) => o.short === share.short
      );
      return ((marketData.price * share.number)).toFixed(2);
    },
    getFloatingFullProfit(share) {
      let marketData = this.bottomStockList.find(
        (o) => o.short === share.short
      );
      return (marketData.price * share.number - share.costtotal).toFixed(2);
      // return parseFloat((this.getFloatingProfit(share) * share.number)-share.costtotal).toFixed(
      //   2
      // );
    },
    getFloatingProfit(share) {
      let marketData = this.bottomStockList.find(
        (o) => o.short === share.short
      );
      return marketData.price - share.price;
    },
    getFloatingProfitPercentage(share) {
      return parseFloat(
        (this.getFloatingProfit(share) / share.price) * 100
      ).toFixed(2);
    },
    getStockObject(stock) {
      let elements = eval("v_" + stock).split("~");
      let item = {};

      item.name = elements[1]; // 股票名称
      item.code = elements[2]; // 不带字幕的股票代码，603045
      item.short = stock;
      item.price = elements[3]; // 当前价格
      item.yesterdayClosePrice = elements[4]; // 昨收
      item.todayOpenPrice = elements[5]; // 今开

      item.buy1Price = elements[9]; // 买1价格
      item.buy1Num = elements[10]; // 买1数量（手）
      item.buy2Price = elements[11]; // 买2价格
      item.buy2Num = elements[12]; // 买2数量（手）
      item.buy3Price = elements[13]; // 买3价格
      item.buy3Num = elements[14]; // 买3数量（手）
      item.buy4Price = elements[15]; // 买4价格
      item.buy4Num = elements[16]; // 买4数量（手）
      item.buy5Price = elements[17]; // 买5价格
      item.buy5Num = elements[18]; // 买5数量（手）

      item.sell1Price = elements[19]; // 卖1价格
      item.sell1Num = elements[20]; // 卖1数量（手）
      item.sell2Price = elements[21]; // 卖2价格
      item.sell2Num = elements[22]; // 卖2数量（手）
      item.sell3Price = elements[23]; // 卖3价格
      item.sell3Num = elements[24]; // 卖3数量（手）
      item.sell4Price = elements[25]; // 卖4价格
      item.sell4Num = elements[26]; // 卖4数量（手）
      item.sell5Price = elements[27]; // 卖5价格
      item.sell5Num = elements[28]; // 卖5数量（手）

      item.increase = elements[31]; // 涨、跌额
      item.increasePercent = elements[32]; // 涨、跌幅
      item.maxPrice = elements[33]; // 最高价
      item.minPrice = elements[34]; // 最低价

      item.num = elements[36]; // 成交量(手)
      item.totalAccount = elements[37]; // 成交额(万)
      item.turnoverRate = elements[38]; // 换手率
      item.priceToEarnings = elements[39]; // 市盈率

      item.swing = elements[43]; // 振幅
      item.stockMarketsFell = elements[44]; // 流通市值(亿)
      item.aggregatealueListedStock = elements[45]; // 总市值(亿)
      item.price2BookRatio = elements[46]; // 市净率
      item.hardenPrice = elements[47]; // 涨停价
      item.dropPrice = elements[48]; // 跌停价
      item.volumeRatio = elements[49]; // 量比
      item.appointment = elements[50]; // 尾差
      item.average = elements[51]; // 均价

      return item;
    },
    onAccountSelect(item) {
      this.selectedAccount = this.capitalAccountList[item.value];
      this.$store.commit("setSelectedCid", this.selectedAccount.cid);
      this.showPicker = false;
      this.getDealLog();
      this.getEntrustLog();
      this.getDepotStock();
      this.getCapitalData();
    },
    buySellOperation() {
      let that = this;

      if (that.search === "") {
        Dialog.alert({
          message: "请输入交易股票代码",
        }).then(() => {
          // on close
        });
        return;
      }
      if (that.price === "") {
        Dialog.alert({
          message: "请输入股票交易价格",
        }).then(() => {
          // on close
        });
        return;
      }

      if (parseInt(that.quantity) == 0) {
        Dialog.alert({
          message: "请输入股票交易数量",
        }).then(() => {
          // on close
        });
        return;
      }

      let message =
        this.buySellTab === "buy"
          ? "您是否确定买入该股票?"
          : "您是否确认卖出该股票?";

      Dialog.confirm({
        title: "确认交易",
        message: message,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      })
        .then(() => {
          that.buySellApi();
        })
        .catch(() => {});
    },
    buySellApi() {
      let that = this;
      var nozzle = this.buySellTab === "buy" ? "buy_stock" : "sell_stock";
      var cid = this.selectedAccount.cid;
      var code = this.selectedShare;
      var number = this.quantity;
      var price =
        this.priceButtonLabel === this.marketPriceLabel
          ? this.topData.price
          : this.price;
      var mold = this.priceButtonLabel === this.marketPriceLabel ? 2 : 1;

      // Toast.loading({
      //   forbidClick: true,
      // });
      that.$refs.commonLoader.showCommonLoadigIcon();

      this.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: nozzle,
          token: sessionStorage.getItem("token"),
          cid: cid,
          code: code.substring(2),
          price: price,
          number: number,
          mold: mold,
        },
      })
        .then(function (res) {
          that.$refs.commonLoader.hideCommonLoadigIcon();
          if (res.data.code == 1) {
            Toast.success(res.data.msg);
            // that.active = "depot";
            that.onTabClick();
            that.getCapitalAccounts();
          } else if (res.data.code == 2) {
            that.getTradeChannel();
          } else if (res.data.code == 0) {
            Toast.fail(res.data.msg);
          }
        })
        .catch(function () {
          that.$dialog
            .alert({
              title: "线路异常",
              message: "网络状态异常， 请尝试切换线路。",
              confirmButtonText: "切换线路",
            })
            .then(() => {
              that.$router.push({ path: "/api_line_selector" });
            });
        }).finally(() => {
          that.$refs.commonLoader.hideCommonLoadigIcon();
        });
    },

    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      // Toast.loading();
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            // Toast.clear();
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
            // Toast.clear();
            // that.$toast.fail(res.data.msg);
            that.$refs.commonLoader.hideCommonLoadigIcon();
          }
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
            });
            that.showTradeChannelPopup = false;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    onDepotItem(item) {
      this.selectedShare = item.short;
      this.search = this.selectedShare.slice(2);
      this.sellableQty = item.sellable;
      this.loadMarketData(true);
      this.quantity = '';
    },
  },
  mounted: function () {
    this.priceButtonLabel = this.marketPriceLabel;
    this.selectedShare = this.$store.state.searchSelectedShare; //this.$route.params.code? this.$route.params.code: this.$store.state.searchSelectedShare;
    this.buySellTab = this.$route.params.mode ? this.$route.params.mode : "buy";
    if(this.buySellTab == 'position'){
      this.setPositionTab();
    }
    this.price =
      this.buySellTab === "buy"
        ? this.marketPriceBuyLabel
        : this.marketPriceSellLabel;
    if (this.selectedShare) {
      this.search = this.selectedShare.slice(2);
    }

    this.getCapitalAccounts();
    this.loadMarketData();
    this.timerRef = setInterval(() => {
      this.loadMarketData();
      this.onTabClick();
    }, this.timmerFrequncy);
  },
  destroyed: function () {
    clearInterval(this.timerRef);
  },
};
</script>

<style scoped>
.mainSection {
  padding: 0px 10px;
  background: #000000;
  padding-bottom: 15px;
}
.btnBorder {
  text-align: center;
  /* height: 26px; */
  line-height: 26px;
  margin-top: 0px;
  border-radius: 4px;
  color:#ffffff;
  font-size: 12px;
}

.btnText {
  color: #ffffff;
  font-size: 14px;
}

#capitalAccountStyle {
  text-align: left;
  color: #ffffff;
}
.capital {
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #ffffff;
  font-size: 12px;
  margin-top: 6px;
}
.capital1 {
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #ffffff;
  font-size: 12px;
}

.text_style {
  font-size: 14px;
  font-weight: bold;
}

.capital p {
  margin: 0;
  font-size: 12px;
  text-align: left !important;
  /* font-weight: bold; */
}
.align-left {
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Aligns items to the left */
  margin-left:20px;
}
.align-left1 {
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Aligns items to the left */
  margin-left: 15px;
}
.align-left2 {
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Aligns items to the left */
  margin-left: 35px;
}

.align-right {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* Aligns items to the right */
  margin-right: 20px;
}
.align-right1 {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* Aligns items to the right */
  margin-right: 13px;
}
.align-right2 {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* Aligns items to the right */
  margin-right: 35px;
}
.activeBtn {
  background: #000000;
  color:#D02E27;
  margin-top: 2px;
}
.activeBtnb {
  background: #000000;
  color:#2C71FA;
  height: 20px;
  margin-top: 2px;
}

.shareDesign {
  text-align: center;
  line-height: 25px;
  background: #000000;
  margin: 5px 0px -2px 0px;
  height: 15px;
  font-size: 10px;
}

.shareName {
  margin-left: 10px;
  color: #ffffff;
  font-size: 10px;
}

.shareCode {
  color: #ffffff;
}

.increasePrecent {
  margin-right: 10px;
}

.minusSignCol {
  border: 1px solid #707070;
  line-height: 20px;
  height: 30px;
  border-right: 0;
  background: #000000;
  text-align: center;
}

.minusSign {
  background-color: #000000;
  border: none;
  height: 25px;
  color: #D02E27;
  padding: unset;
}
.minusSignb {
  background-color: #000000;
  border: none;
  height: 25px;
  color: #2C71FA;
  padding: unset;
}

.limitValue {
  border: 1px solid #707070;
  border-bottom: 1px solid #707070 !important;
  line-height: 20px;
  height: 30px;
  text-align: center;
  border-right: 0;
}

.plusSignCol {
  border: 1px solid #707070;
  line-height: 20px;
  height: 30px;
  background: #000000;
  text-align: center;
}
.plusSign {
  background-color: #000000;
  border: none;
  height: 25px;
  color: #D02E27;
  padding: unset;
}
.plusSignb{
  background-color: #000000;
  border: none;
  height: 25px;
  color: #2C71FA;
  padding: unset;
}

.lossAmt {
  border: 1px solid #707070;
  padding: 0px 4px;
  margin-top: 2px;
  color: #ffffff;
  font-size: 12px;
  width: max-content;
  height:15px;
}

.warehouse {
  width: 100%;
  background: #000000;
  border: 1px solid #707070;
  height: 25px;
  font-size: 11px;
  margin-top: 0px;
  border-radius: 0px !important;
}
.redText {
  color: #D02E27;
}
.greenText {
  color: #3F7A21;
}

.dealPopupRow td {
  padding: 5px;
}

.dealPopupRow td span {
  font-size: 13px;
}

.tradingQtyStyle {
  background-color: #0938f1;
}
.tradingQtyBuy{
  background-color: #D02E27;
  border: 1px solid #D02E27;
}
.tradingQtySell{
  background-color: #2C71FA;
  border: 1px solid #2C71FA;
}
.optionList {
  text-align: center;
  width: 100%;
  line-height: 40px;
  background: #ffffff;
  font-size: 14px;
}

.text-border {
  border: 1px solid #D02E27;
  padding: 5px;
  border-radius: 10px;
}

.rowDesign {
  text-align: center;
  line-height: 10px;
  padding-top: 5px;
}

.columnDesign {
  height: 60px;
  line-height: 60px;
  background: #ffffff;
  background: url(../assets/images/line.png) right no-repeat;
  background-size: 1px 35px;
}

.topValue {
  text-align: center;
  line-height: 10px;
  padding-top: 14px;
}

.custom-dropdown >>>.van-dropdown-menu__bar{
  height: 0!important;
}
.custom-dropdown >>>.van-dropdown-item__content{
  margin-top: 30px!important;
  padding: 10px!important;
}
.custom-dropdown >>>.van-overlay{
  margin-top: 30px!important;
}
.custom-dropdown >>>.van-dropdown-menu__title::after {
  border: 5px solid !important;
  border-color: transparent transparent #dcdee0 #dcdee0!important;
}
.custom-dropdown >>>.van-dropdown-menu__title--active::after {
  border-color: transparent transparent #D02E27 #D02E27!important;;
}
.placeholder-input ::placeholder {
  color: #707070 !important; /* Change to your desired color */
  opacity: 1; /* Ensures full opacity */
}
.inputfield ::placeholder {
  color: #707070 !important; /* Change to your desired color */
  opacity: 1; /* Ensures full opacity */
}
.belowtable {
  margin-top: -50px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: #ffffff;
  padding: 15px 10px 10px 10px;
}

.depot-row {
  border-bottom: 1px solid #f0f0f0;
  padding: 3px 0;
}
/deep/ .van-picker__confirm {
  color: #0D268D !important;
}
</style>

<style>
/* Hide the tab bar for all van-tabs */
#detailTable .van-tabs__wrap {
  display: none;
}
.placeholder-input .van-field__control {
  text-align: left !important;
}


#detailTable .van-tab {
  background: #dcdee0;
  color: #0D268D;
}

#detailTable .van-tab--active {
  background: #0D268D !important;
  color: #ffffff;
}

#detailTable .van-tabs__line {
  display: none;
}

#detailTable1 .van-tabs__wrap {
  height: 25px !important;
  margin-top: -2px;
}
#detailTable1 .van-tab {
  background: #f0f0f0;
  color: #0D268D;
  font-size: 12px;
}

#detailTable1 .van-tab--active {
  background: #0D268D !important;
  color: #ffffff;
}

#detailTable1 .van-tabs__line {
  display: none;
}

#searchStyle {
  height: 30px; /* Set height for the container */
  display: flex;
  align-items: center; /* Ensure vertical alignment */
}

#searchStyle .van-field__control {
  height: 30px !important; /* Override any inherited styles */
  line-height: 30px !important; /* Ensure text is vertically aligned */
  color: #989898 !important;
  text-align: center;
  font-size: 12px;
  background-color: #000000;
}


#capitalAccountStyle .van-field__control {
  color: #ffffff !important;
  text-align: left;
  font-size: 12px;
}

#tradingAgreePop p {
  margin: 0 !important;
}

#tradingAgreePop .van-popup__close-icon--top-right {
  top: 0px;
  right: 0px;
}
.tradingnav{
  background: #000000;
  margin-left: -8px;
  margin-right: -9px;
  margin-bottom: 8px;
  border: 1px solid #707070;
  height: 28px;
}
.shareavailable {
  margin-top: 8px;
  font-size: 10px;
  height: 15px;
  display: flex;
  align-items: center;
  padding-left: 2px;
}
#border-box {
  border: 1px solid #707070;
  /* padding-bottom: 8px; */
  margin-left: 4px;
  width: 36%;
  font-size: 10px;
  background-color: #000000 !important;
}
.dealPopupRow {
  border-bottom: 1px solid #ddd; /* Light gray line */
}

.dealPopupRow:last-child {
  border-bottom: none; /* Remove border from the last row */
}
.flex-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

</style>


// WEBPACK FOOTER //
// src/components/Trading.vue